<template>
	<li class="leftsidebar__model-link">
		<router-link :to="{name: 'model', params: {name: name}}">
			<p
				:class="{
					'leftsidebar--active': active,
					'hidden-phone': !this.$store.state.app.sidebars.left,
				}"
			>
				{{ text }}
			</p>
		</router-link>
	</li>
</template>

<script>
export default {
	name: 'LeftSidebarModelLink',
	props: {
		name: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		active: Boolean,
	},
};
</script>
